import { post } from "config/infra";
import { ChangePhoneRequest, ChangePhoneResponse } from "domain/entity/Phone";
import PhoneRepository from "domain/repository/Phone";

export default class PhoneApi implements PhoneRepository {
    async postChangePhone(body: ChangePhoneRequest): Promise<ChangePhoneResponse> {
        return post<ChangePhoneResponse, ChangePhoneRequest>('/phone/change', body)
    }
}